import { withSvgIcon } from './withSvgIcon';

export const Delete = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.5 3H8.5V5H9.5H14.5H15.5V3H14.5H9.5ZM5.5 6H4.5V8H5.5H6.11722L7.39823 18.2481C7.52333 19.2489 8.37413 20 9.38278 20H14.6172C15.6259 20 16.4767 19.2489 16.6018 18.2481L17.8828 8H18.5H19.5V6H18.5H17H7H5.5ZM9.38278 18L8.13278 8H15.8672L14.6172 18H9.38278Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
